
      //Preloader Website
      //$(window).load(function() {
      //   $('#loader-wrapper').delay(0).fadeOut();
      //   $('#loader').delay(0).fadeOut('slow');
      //});

$(document).ready(function() {     
    

      // Sticky Navabr
      //$("header").before($(".top-bar").clone().addClass("slidedown"));
      //$(window).on("scroll", function () {
      //   $("body").toggleClass("slide-menu", ($(window).scrollTop() > 600));
      //});
      
      
      //--------------------------------------------

      
      // One Page Navigation	   
	    $.scrollIt({	   
	      scrollTime: 1400,
	      easing: 'easeInOutExpo',
	      topOffset: -20,
	    });
      

      // Testimonials Carousel
      $("#spell-carousel").owlCarousel({
         items: 2,
         itemsDesktop: [1199,2],
         itemsDesktopSmall: [991,2],
         itemsTablet: [768,1],
         slideSpeed: 800,
         navigation: true,
         navigationText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
         pagination: true,
         autoHeight: true,
         autoPlay: true,
      });

    //$('#myCarousel').carousel({
    //    interval: false
    //});
    //
    //var clickEvent = false;
    //$('#myCarousel').on('click', '.nav a', function() {
    //    clickEvent = true;
    //    $('.nav li').removeClass('active');
    //    $(this).parent().addClass('active');
    //}).on('slid.bs.carousel', function(e) {
    //    if(!clickEvent) {
    //        var count = $('.nav').children().length -1;
    //        var current = $('.nav li.active');
    //        current.removeClass('active').next().addClass('active');
    //        var id = parseInt(current.data('slide-to'));
    //        if(count == id) {
    //            $('.nav li').first().addClass('active');
    //        }
    //    }
    //    clickEvent = false;
    //});

      //-----------------------------------------------
      
      
      // Tooltip
      $('[data-toggle="tooltip"]').tooltip()


      // Mobile Navi Click
      $('nav a').on('click', function(){ 
       if($('.navbar-toggle').css('display') !='none'){
           $(".navbar-toggle").trigger( "click" );
       }
      });

        var cookie_consent = readCookie('_cc');

        if(cookie_consent == null) {
            show_cookie_consent();
        }
});


function show_cookie_consent() {
  var notif = $('<div class="cookie-notification"><div class="cookie-notification-bar"><div class="title">Privacy & Cookies</div>' +
      'Wij en onze <a href="/privacy#partners">partners</a> gebruiken cookies en vergelijkbare technologieën om de inhoud van onze website op de gebruiker af te stemmen, advertenties te personaliseren en ons verkeer te analyseren. Onze partners kunnen deze informatie combineren met informatie die zij via andere bronnen hebben verkregen.<br/> Door op Ok te klikken of onze site te gebruiken, ga je akkoord met de voorwaarden zoals beschreven in ons <a href="/privacy#cookies">Cookiebeleid</a>.<br/><button>Ok!</button></div></div>');
  notif.find('button').click(function() {
      notif.remove();
      setCookie('_cc', true, 725);
      eraseCookie('_cc_v');
  });
  notif.hide();
  $('body').append(notif);
  notif.fadeIn();

  // Increment view count, set consent to true after 5 views
  var view_count = readCookie('_cc_v');
  if(view_count == null) setCookie('_cc_v', 1);
  else {
      view_count = parseInt(view_count);
      if(view_count >= 3) {
          setCookie('_cc', true, 725);
          eraseCookie('_cc_v');
      } else {
          setCookie('_cc_v', (view_count+1));
      }
  }
}


function setCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
window.setCookie = setCookie;

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
window.readCookie = readCookie;

function eraseCookie(name) {
  setCookie(name,"",-1);
}

// E-mail validation
function isValidEmailAddress(emailAddress) {
  var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
  return pattern.test(emailAddress);
}; 

// Phone Slider Function
function getSlide() {
    var wW = $(window).width();
    if (wW < 601) {
        return 1;
    }
    return 3;
}
